import type { NUtils } from '@app/types/Utils';

export const adaptDateFromSelects: NUtils.AdaptDateFromSelects = (
  day,
  month,
  year
) => {
  const handledDay = Number(day) < 10 ? `0${day}` : day;
  const handledMonth = Number(month) < 10 ? `0${month}` : month;

  return `${year}-${handledMonth}-${handledDay}`;
};
